import React, { useRef } from 'react';
import axios from 'axios';
import { chatbotApi } from '../common/src';
import Filter from 'badwords-ko';

const MessageParser = ({ children, actions }) => {
  const sessionKey = useRef('');

  // //console.log(children);
  // const userid = children.props.headerText;

  // let sessionKey = children.props.state.sessionKey;
  // let userid = children.props.state.id;
  // //console.log('===========>' + sessionKey);
  //console.log(children);

  const _sendDialogFlow = async (message) => {
    //console.log('sendDialogStart....');

    const customFilter = new Filter({ placeHolder: ' ' });
    const cleanMessage = customFilter.clean(message).replace(/[ ]*$/g, '');
    //console.log(cleanMessage);
    // //console.log('===========>' + sessionKey.current);
    // //console.log(children.props.state.id);
    const userid = children.props.state.id;
    const pkg = children.props.state.pkg;
    const sessionKey = children.props.state.sessionKey;

    const result = await axios.get(chatbotApi + '/dialog', {
      params: {
        q: cleanMessage,
        i: userid,
        s: sessionKey,
        p: pkg,
      },
    });
    //console.log(result);
    return result.data.returnText;
    // //console.log(result.data.returnText);
  };

  const parse = async (message) => {
    // //console.log('===========>' + sessionKey);
    const customFilter = new Filter({ placeHolder: ' ' });
    const cleanMessage = customFilter.clean(message).replace(/[ ]*$/g, '');
    //console.log(message);

    // //console.log(customFilter.clean('욕을 합니다 개새끼')); // 욕을 합니다 xxx

    // const filter = new Filter();
    // //console.log(filter.clean('욕을 합니다 개새끼')); // 욕을 합니다 ***

    if (
      cleanMessage === undefined ||
      cleanMessage === null ||
      cleanMessage === ''
    ) {
      actions.customMessage(
        'customTextMessage',
        '문의할 내용을 입력해 주세요',
        '',
        false
      );
    } else {
      const returnMessage = await _sendDialogFlow(cleanMessage);
      if (
        returnMessage === undefined ||
        returnMessage === null ||
        returnMessage === ''
      ) {
        actions.customMessage(
          'customTextMessage',
          '응답중 오류가 발행했습니다.\n다시 시도해 주세요',
          'widget-prev',
          false,
          ''
        );
        return;
      }
      const jsonMessage = JSON.parse(returnMessage);

      //console.log(jsonMessage);
      ////console.log(typeof jsonMessage.message);

      let widgetName = '';
      let widget = false;
      let param = '';
      let date = '';
      let icon = '';
      if (jsonMessage.message) {
        const isList = isJson(jsonMessage.message);
        // //console.log(jsonMessage.type);
        if (isList) {
          const msg = JSON.parse(jsonMessage.message);
          if (msg.type === 'card') {
            widgetName = msg.widgetName;
            //console.log(widgetName);
            widget = true;

            actions.customMessageCard(
              'customTextMessage',
              jsonMessage.message,
              widgetName,
              widget,
              msg.cardData
            );
          } else if (msg.type === 'list') {
            widgetName = msg.widgetName;
            if (msg.param) {
              param = msg.param;
            }
            if (msg.date) {
              date = msg.date;
            }
            //console.log(widgetName);
            widget = true;

            actions.customMessage(
              'customTextMessage',
              msg.message,
              '',
              false,
              param,
              date,
              icon
            );

            setTimeout(() => {
              actions.customMessageList(
                'customSelectMessage',
                msg.message,
                widgetName,
                widget,
                msg.listData,
                param,
                date
              );
            }, 1000);
          } else if (msg.type === 'msg') {
            widgetName = msg.widgetName;
            widget = true;

            actions.customMessage(
              'customTextMessage',
              msg.message,
              widgetName,
              widget
            );
          } else if (msg.type === 'withImg') {
            widgetName = msg.widgetName;
            widget = true;
            icon = msg.icon;

            // customName, message, widgetName, widget, list
            actions.customMessage(
              'customImgMessage',
              msg.message,
              widgetName,
              widget,
              '',
              '',
              icon
            );
          } else if (msg.type === 'lateWidget') {
            widgetName = msg.widgetName;
            widget = true;

            actions.customMessageLate(
              'customTextMessage',
              msg.message,
              widgetName,
              widget,
              '',
              '',
              msg.listData
            );
          } else if (msg.type === 'waitForApi') {
            widgetName = msg.widgetName;
            param = msg.param;
            widget = true;

            actions.customMessage(
              'customTextMessage',
              msg.message,
              widgetName,
              widget,
              param
            );
            //api 조회해서 답하나... 아님 그냥 widget로 만드는게 낫나....widget 이 깔끔할 것 같다.
            // setTimeout(() => {
            //   actions.customMessage(
            //     'customTextMessage',
            //     '내용 조회 완료',
            //     widgetName,
            //     widget,
            //     param
            //   );
            // }, 2000);
          }
        } else {
          // if (jsonMessage.message.includes('계정')) {
          //   widgetName = 'widget-login';
          //   widget = true;
          // }

          widgetName = 'widget-prev';
          widget = true;

          actions.customMessage(
            'customTextMessage',
            jsonMessage.message,
            widgetName,
            widget,
            '',
            '',
            icon
          );
        }
      } else {
      }
    }

    // }
  };
  const isJson = (str) => {
    try {
      var json = JSON.parse(str);
      return typeof json === 'object';
    } catch (e) {
      return false;
    }
  };

  const _clientMessage = (message) => {
    actions.handleClientMessage(message);
    parse(message);
  };
  const _categorySelect = (categoryCode, msg, skey) => {
    // //console.log(actions);
    sessionKey.current = skey;
    actions.setSession(sessionKey.current);
    actions.handleCategorySelect(categoryCode, msg);
    parse(msg);
  };
  const _categorySubSelect = (msg) => {
    actions.handleCategorySubSelect(msg);
    parse(msg);
  };
  const _home = (dept) => {
    //console.log(dept);
    actions.handleHome(dept);
  };
  const _categoryPrev = (msg) => {
    actions.handlePrev(msg);
    parse(msg);
  };
  const _yesNo = (msg) => {
    actions.handleYesno(msg);
    parse(msg);
  };
  const _yesNo_yesAnswer = (msg) => {
    actions.handleYesno(msg);
  };
  const _yesNo_yesAnswer_parse = (msg) => {
    actions.handleYesno(msg);
    parse(msg);
  };
  const _timeline = (contentSerial, title) => {
    actions.handleTimeline(title + ' 편성정보', contentSerial);
    // parse(title + ' 편성정보');
  };

  const _yesNo_noAnswer = (msg) => {
    actions.handleYesno(msg);
    parse(msg);
  };

  const _checkLogin = (msg) => {
    actions.handleLogin(msg);
    // parse(msg);
  };
  const _selectEtc = (msg, skey) => {
    sessionKey.current = skey;
    actions.handleEtc(msg);
  };
  const _selectQna = (msg, skey) => {
    sessionKey.current = skey;
    actions.handleQna(msg);
    parse(msg);
  };
  const _selectChat = (msg, skey) => {
    sessionKey.current = skey;
    actions.handleChat(msg);
  };
  const _qnaSuccess = (msg) => {
    actions.handleQnaSuccess(msg);
  };
  const _sameCodeSelect = (msg) => {
    actions.handleSameCodeSelect(msg);
    parse(msg);
  };
  const _introStart = () => {
    actions.handleIntroStart();
  };
  const _end = () => {
    localStorage.removeItem('chat_messages');
    actions.handleEnd();
  };
  const _simpleMsg = (msg) => {
    actions.handleSimpleMsg(msg);
  };
  const _deliveryMsg = (orderCode, SaleType, goodSerial, deliverySate) => {
    actions.handleDeliveryInfo(orderCode, SaleType, goodSerial, deliverySate);
  };
  const _cancelMsg = (
    orderCode,
    SaleType,
    goodSerial,
    deliverySate,
    saleEnd,
    goodTotalPrice
  ) => {
    actions.handleCancelInfo(
      orderCode,
      SaleType,
      goodSerial,
      deliverySate,
      saleEnd,
      goodTotalPrice
    );
  };
  const _returnMsg = (
    orderCode,
    SaleType,
    goodSerial,
    deliverySate,
    saleEnd,
    goodTotalPrice
  ) => {
    actions.handleReturnInfo(
      orderCode,
      SaleType,
      goodSerial,
      deliverySate,
      saleEnd,
      goodTotalPrice
    );
  };
  return (
    <div>
      {React.Children.map(children, (child) => {
        return React.cloneElement(child, {
          parse: parse,
          actions: {
            _clientMessage,
            _categorySelect,
            _categorySubSelect,
            _home,
            _categoryPrev,
            _yesNo,
            _yesNo_yesAnswer,
            _yesNo_yesAnswer_parse,
            _yesNo_noAnswer,
            _checkLogin,
            _selectEtc,
            _selectQna,
            _qnaSuccess,
            _selectChat,
            _sameCodeSelect,
            _introStart,
            _end,
            _simpleMsg,
            _timeline,
            _deliveryMsg,
            _cancelMsg,
            _returnMsg,
          },
        });
      })}
    </div>
  );
};

// export default shopContext(withRouter(MessageParser));
export default MessageParser;
